var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"badge",class:_vm.badgeColor},[_vm._v(" "+_vm._s(_vm.badgeText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }